import { render } from "./BotModal.vue?vue&type=template&id=00f228f9&scoped=true"
import script from "./BotModal.vue?vue&type=script&lang=js"
export * from "./BotModal.vue?vue&type=script&lang=js"

import "./BotModal.vue?vue&type=style&index=0&id=00f228f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f228f9"]])

export default __exports__